import { render } from "./DealerListItem.vue?vue&type=template&id=c8444df2"
import script from "./DealerListItem.vue?vue&type=script&lang=js"
export * from "./DealerListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__